import BlankLayout from './BlankLayout'

export { BlankLayout }

export default BlankLayout
